import { promo } from './promo.js';
import { MARK } from './mark.js';

export function footer() {
  return `
  <footer id="privacy">
    <div class="wrap foot-grid">
      <span class="foot-brand">${MARK} cruxdiff — your files never leave this tab.</span>
      <a href="/privacy.html">Privacy &amp; how it works</a>
      <a href="/about.html">About &amp; terms</a>
      <a href="mailto:hello@cruxdiff.com?subject=cruxdiff%20feedback">Feedback</a>
      <a href="/parquet-viewer.html">Parquet viewer</a>
      <a href="/pro.html">Pro</a>
      <a href="/go/">All comparison tools</a>
      <!-- Hidden until they have real destinations — re-enable when live: <a href="/cli">CLI</a><a href="/changelog">Changelog</a> -->
    </div>
    ${promo()}
  </footer>`;
}
